class GalleryRow extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.track = this.querySelector('[data-gallery-track]');
    this.prevBtn = this.querySelector('[data-gallery-prev]');
    this.nextBtn = this.querySelector('[data-gallery-next]');
    if (!this.track || !this.prevBtn || !this.nextBtn) return;

    this.mq = window.matchMedia('(max-width: 767px)');
    this.onScroll = () => this.updateButtons();
    this.onResize = () => this.updateButtons();
    this.onMqChange = () => this.updateButtons();

    this.prevBtn.addEventListener('click', () => this.scrollByItem(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByItem(1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    if (typeof this.mq.addEventListener === 'function') {
      this.mq.addEventListener('change', this.onMqChange);
    } else {
      this.mq.addListener(this.onMqChange);
    }

    this.track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', this.onResize, { once: true });
      }
    });

    this.updateButtons();
  }

  disconnectedCallback() {
    this.dataset.initialized = 'false';
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (!this.mq) return;
    if (typeof this.mq.removeEventListener === 'function') {
      this.mq.removeEventListener('change', this.onMqChange);
    } else {
      this.mq.removeListener(this.onMqChange);
    }
  }

  isRowMode() {
    const mobile = this.mq ? this.mq.matches : window.matchMedia('(max-width: 767px)').matches;
    return mobile ? this.dataset.mobileRow === 'true' : this.dataset.pcRow === 'true';
  }

  getItemStep() {
    const item = this.track.querySelector('.gallery-carousel__item');
    if (!item) return this.track.clientWidth;
    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  scrollByItem(direction) {
    if (!this.isRowMode()) return;
    const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const next = this.track.scrollLeft + direction * this.getItemStep();
    const left = Math.max(0, Math.min(maxScroll, next));
    this.track.scrollTo({ left, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.isRowMode()) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const canScroll = maxScroll > 2;
    const atStart = this.track.scrollLeft <= 2;
    const atEnd = this.track.scrollLeft >= maxScroll - 2;
    this.prevBtn.disabled = !canScroll || atStart;
    this.nextBtn.disabled = !canScroll || atEnd;
  }
}

if (!customElements.get('gallery-row')) {
  customElements.define('gallery-row', GalleryRow);
}
